<template>
  <div>
    <b-modal
      :id="infoModalProyecto.id"
      :title="infoModalProyecto.title"
      ok-only
      size="lg"
    >
      <Proyecto :itemAnyadido="itemAnyadir" ref="Proyecto"></Proyecto>
    </b-modal>

    <div>
      <strong>Item List</strong>
      <b-button
        variant="outline-success"
        class="mb-2 ml-3 actionButton"
        v-b-modal.itemconfiguration
        pill
        size="sm"
      ><i class="fas fa-plus-circle"></i></b-button>

      <b-table
        style="font-size: 90%"
        class="shadow-sm"
        responsive
        id="itemsTable"
        :fields="dynamicTableFields"
        :items="itemList"
        :primary-key="'id'"
        bordered
        hover
        small
      >
        <template #cell(descripcion)="data">
          {{
            openTraining
              ? data.item.cliente && data.item.cliente.nombre
                ? data.item.cliente.nombre
                : "Sin cliente"
              : data.item.descripcion
          }}
        </template>
        <template #cell(fechaEntrega)="data">
          {{
            data.item.hitoEntregas && data.item.hitoEntregas.length > 0
              ? data.item.hitoEntregas[0].fechaEntrega
              : ""
          }}
        </template>
        <template #cell(fechaEntregaActualizada)="data">
          {{
            data.item.hitoEntregas && data.item.hitoEntregas.length > 1
              ? data.item.hitoEntregas[data.item.hitoEntregas.length - 1].fechaEntrega
              : ""
          }}
        </template>

        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
          </div>
        </template>

        <template #cell(action)="row">
          <b-button-group class="col-md-5" size="sm">
            <b-button
              size="sm"
              variant="outline-info"
              data-toggle="collapse"
              :disabled="!['ROLE_SUPERADMIN','ROLE_TRAINING','ROLE_SALES'].includes(currentUser.roles[0])"
              @click="modalProyecto($event.target, row.item)"
              class="botonAccion ml-1"
            >
              <i class="fa fa-copy fa-1x"></i>
            </b-button>

            <b-button
              size="sm"
              class="actionButton ml-1"
              variant="outline-success"
              @click="loadItem(row)"
            ><i class="fas fa-edit"></i></b-button>

            <b-button
              v-if="['TRAINING', 'OPENTRAINING', 'ELEARNING'].includes(row.item.tipoServicio) && crearCurso===true"
              size="sm"
              class="actionButton ml-1"
              variant="outline-warning"
              @click="irAProyectoYItem2(row.item)"
            >
              <i class="fas fa-chalkboard-teacher"></i>
            </b-button>

            <b-button
              v-if="!row.item.observacionItem || row.item.observacionItem === ''"
              class="actionButton mr-2"
              variant="outline-primary"
              v-b-modal.modal-observaciones-item
              @click="abrirObservacion(row.item)"
            ><i class="fas fa-comment-dots"></i></b-button>

            <b-button
              v-else
              class="actionButton mr-2"
              variant="outline-danger"
              v-b-modal.modal-observaciones-item
              @click="abrirObservacion(row.item)"
            ><i class="fas fa-comment-dots"></i></b-button>

            <b-button
              :disabled="!['ROLE_SUPERADMIN'].includes(currentUser.roles[0])"
              size="sm"
              class="actionButton ml-1"
              variant="outline-danger"
              @click="deleteLineItem(row)"
            ><i class="fas fa-trash-alt"></i></b-button>
          </b-button-group>
        </template>

        <template #row-details="row">
          <b-card>
            <vue-json-pretty
              :showDoubleQuotes="false"
              :showIcon="true"
              :data="row.item"
            />
          </b-card>
        </template>
      </b-table>
    </div>

    <b-modal
      id="itemconfiguration"
      ref="itemconfiguration"
      title="Item"
      size="xl"
      hide-footer
      @show="modalAbierta = true"
      @hide="handleItemBeforeHide"
    >
      <b-row class="mt-3">
        <b-col>
          <b-card>
            <b-row class="mt-2 mb-4">
              <b-col cols="7" v-if="this.openTraining == true">
                <label for="cliente" class="form-label">Account Name</label>
                <div class="input-group mb-2">
                  <b-form-select v-model="cliente" size="sm" @change="updateCIF">
                    <option :value="null">-- Ninguno --</option>
                    <option v-for="cli in clientes" :value="cli" :key="cli.id">
                      {{ cli.nombre }}
                    </option>
                  </b-form-select>
                  <p
                    v-if="cliente == ''"
                    class="error-message"
                    style="font-size: 12px; color: rgb(8, 92, 19)"
                  >
                    Campo Obligatorio
                  </p>

                  <div class="input-group-prepend">
                    <b-button size="sm" variant="outline-success" @click="modalCliente">
                      <i class="fas fa-plus-circle"></i>
                    </b-button>
                  </div>
                </div>

                <p
                  v-if="cliente == null"
                  class="error-message"
                  style="font-size: 12px; color: rgb(8, 92, 19)"
                >
                  Campo Obligatorio
                </p>
              </b-col>

              <b-modal
          :id="infoModalCliente.id"
          :title="infoModalCliente.title"
          ok-only
          size="lg"
          @hidden="cargarClientes"
        >
          <Clientes ref="Cliente" :is-selection-mode="true" @client-selected="handleClientSelected"></Clientes>
        </b-modal>

              <b-col v-if="this.openTraining == true">
                <label for="cif">CIF</label>
                <b-form-input
                  class="form-control"
                  size="sm"
                  v-model="cif"
                  id="cif"
                ></b-form-input>
              </b-col>
            </b-row>

            <b-row class="mb-3 mt-3">
              <b-row class="mb-3 mt-3">
                <b-col cols="2">
                  <label for="numeroItem" class="form-label">Numero Item</label>
                  <b-form-input
                    @click="crearCurso===true ? irAProyectoYItem: null"
                    size="sm"
                    v-model="numeroItem"
                    :class="{
                      subrayado: ['TRAINING', 'OPENTRAINING', 'ELEARNING'].includes(tipoServicio) && !openTraining && crearCurso === true
                    }"
                    id="numeroItem"
                    :disabled="
                      this.$store.state.auth.user.roles[0] !== 'ROLE_SALES' &&
                      this.$store.state.auth.user.roles[0] !== 'ROLE_SUPERADMIN' &&
                      this.$store.state.auth.user.roles[0] !== 'ROLE_MANAGER' &&
                      this.$store.state.auth.user.roles[0] !== 'ROLE_TRAINING'
                    "
                  ></b-form-input>

                  <p
                    v-if="numeroItem == ''"
                    class="error-message"
                    style="font-size: 12px; color: rgb(8, 92, 19)"
                  >
                    Campo Obligatorio
                  </p>
                </b-col>

                <b-col cols="2">
                  <label for="numeroPedido" class="form-label">Numero Pedido</label>
                  <b-form-input
                    size="sm"
                    v-model="numeroPedido"
                    id="numeroPedido"
                    :disabled="
                      this.$store.state.auth.user.roles[0] !== 'ROLE_SALES' &&
                      this.$store.state.auth.user.roles[0] !== 'ROLE_SUPERADMIN' &&
                      this.$store.state.auth.user.roles[0] !== 'ROLE_FINANCE' &&
                      this.$store.state.auth.user.roles[0] !== 'ROLE_MANAGER' &&
                      this.$store.state.auth.user.roles[0] !== 'ROLE_TRAINING'
                    "
                  ></b-form-input>
                </b-col>

                <b-col cols="2">
                  <label for="importeItem" class="form-label">Importe Item</label>
                  <b-form-input
                    :disabled="
                      this.$store.state.auth.user.roles[0] !== 'ROLE_SUPERADMIN' &&
                      this.id != ''
                    "
                    size="sm"
                    v-model.number="importeItem"
                    id="importeItem"
                  ></b-form-input>
                </b-col>

                <b-col cols="3" v-show="!openTraining">
                  <label for="fechaPrimerContactoItem" class="form-label">Fecha Primer Contacto</label>
                  <b-form-datepicker
                    style="background: rgb(228, 245, 229)"
                    size="sm"
                    v-model="fechaPrimerContactoItem"
                    id="fechaPrimerContactoItem"
                    resetButton
                  ></b-form-datepicker>
                </b-col>

                <b-col cols="3" v-show="!openTraining">
                  <label for="fechaVisita" class="form-label">Fecha Visita</label>
                  <b-form-datepicker
                    style="background: rgb(228, 245, 229)"
                    size="sm"
                    v-model="fechaVisita"
                    id="fechaVisita"
                    resetButton
                  ></b-form-datepicker>
                </b-col>
              </b-row>

              <b-row class="mb-2 mt-3" v-show="openTraining">
                <b-col cols="4">
                  <label for="sector">Sector</label>
                  <b-form-select
                    size="sm"
                    class="ml-1 mr-1 mt-1 mb-1"
                    v-model="sector"
                    :options="localOptionsSectores"
                    :disabled="
                      this.$store.state.auth.user.roles[0] !== 'ROLE_SALES' &&
                      this.$store.state.auth.user.roles[0] !== 'ROLE_SUPERADMIN' &&
                      this.$store.state.auth.user.roles[0] !== 'ROLE_MANAGER' &&
                      this.$store.state.auth.user.roles[0] !== 'ROLE_TRAINING'
                    "
                  >
                  </b-form-select>
                </b-col>
              </b-row>

              <b-row class="mb-5 mt-4">
                <b-col cols="3">
                  <label for="tipoProyecto" class="form-label">Tipo Proyecto</label>
                  <b-form-select
                    :disabled="
                      this.$store.state.auth.user.roles[0] !== 'ROLE_SUPERADMIN' &&
                      this.id != ''
                    "
                    size="sm"
                    v-model="tipoProyecto"
                    :options="sortedOptionsTipoProyectoEsp"
                  >
                  </b-form-select>
                  <p
                    v-if="tipoProyecto === ''"
                    class="error-message"
                    style="font-size: 12px; color: rgb(8, 92, 19)"
                  >
                    Campo Obligatorio
                  </p>
                </b-col>

                <b-col cols="3">
                  <label for="tipoServicio" class="form-label ml-5">Tipo Servicio</label>
                  <b-form-select
                    class="ml-5"
                    size="sm"
                    v-model="tipoServicio"
                    :options="$constants().optionsClaseProyectoESP"
                    @change="cambiarValorCheckbox"
                    :disabled="
                      this.$store.state.auth.user.roles[0] !== 'ROLE_SALES' &&
                      this.$store.state.auth.user.roles[0] !== 'ROLE_SUPERADMIN' &&
                      this.$store.state.auth.user.roles[0] !== 'ROLE_MANAGER' &&
                      this.$store.state.auth.user.roles[0] !== 'ROLE_TRAINING'
                    "
                  >
                  </b-form-select>
                  <p
                    v-if="tipoServicio == ''"
                    class="error-message ml-5"
                    style="font-size: 12px; color: rgb(8, 92, 19)"
                  >
                    Campo Obligatorio
                  </p>
                </b-col>

                <b-col cols="3">
                  <label for="fechaPedido" class="form-label" style="margin-left: 95px">Fecha Pedido</label>
                  <b-form-datepicker
                    size="sm"
                    v-model="fechaPedido"
                    id="fechaPedido"
                    rows="1"
                    style="margin-left: 95px"
                    resetButton
                    :disabled="
                      this.$store.state.auth.user.roles[0] !== 'ROLE_SALES' &&
                      this.$store.state.auth.user.roles[0] !== 'ROLE_SUPERADMIN' &&
                      this.$store.state.auth.user.roles[0] !== 'ROLE_MANAGER' &&
                      this.$store.state.auth.user.roles[0] !== 'ROLE_TRAINING'
                    "
                  ></b-form-datepicker>
                </b-col>

                <b-col cols="1">
                  <label for="cuasiPedido" class="form-label" style="margin-left: 95px">CuasiPedido</label>
                  <input
                    type="checkbox"
                    class="custom-checkbox"
                    v-model="cuasiPedido"
                    style="margin-left: 120px"
                    @change="seleccionarCheckboxcuasiPedido"
                    :disabled="
                      this.$store.state.auth.user.roles[0] !== 'ROLE_SALES' &&
                      this.$store.state.auth.user.roles[0] !== 'ROLE_SUPERADMIN' &&
                      this.$store.state.auth.user.roles[0] !== 'ROLE_TRAINING'
                    "
                  />
                </b-col>
              </b-row>

              <b-row>
                <b-col cols="2" class="mt-2 mb-2" v-show="!openTraining">
                  <b-form-checkbox
                    :disabled="
                      this.$store.state.auth.user.roles[0] !== 'ROLE_SALES' &&
                      this.$store.state.auth.user.roles[0] !== 'ROLE_SUPERADMIN' &&
                      this.$store.state.auth.user.roles[0] !== 'ROLE_TRAINING' &&
                      this.$store.state.auth.user.roles[0] !== 'ROLE_MANAGER'
                    "
                    v-model="parado"
                    name="check-button"
                    switch
                  >
                    StandBy
                  </b-form-checkbox>
                </b-col>
              </b-row>

              <b-row class="mt-3 mb-3" v-show="!openTraining">


                <b-col>
                  <label for="informacionFaseOferta" class="form-label">Información Fase Oferta</label>
                  <b-form-textarea
                    class="form-control"
                    size="sm"
                    v-model="informacionFaseOferta"
                    id="informacionFaseOferta"
                    rows="8"
                    no-resize
                  ></b-form-textarea>
                </b-col>
              </b-row>



              <b-row v-show="!openTraining">
                <b-col>
                  <b-card
                    style="background-color: rgb(247, 247, 247)"
                    class="mt-4 mb-4"
                  >
                    <HitosEntregaItem ref="hitosEntregaItem" class="mt-1 mb-1" />
                  </b-card>
                </b-col>
              </b-row>

              <b-row class="mt-3 mb-3" v-show="!openTraining">
                <b-col>
                  <label for="descripcion" class="form-label">Descripción</label>
                  <b-form-textarea
                    class="form-control"
                    size="sm"
                    v-model="descripcion"
                    id="descripcion"
                    rows="5"
                    no-resize
                     :disabled="
                        this.$store.state.auth.user.roles[0] !== 'ROLE_SALES' &&
                        this.$store.state.auth.user.roles[0] !== 'ROLE_SUPERADMIN' &&
                        
                        this.$store.state.auth.user.roles[0] !== 'ROLE_TRAINING'
                      "
                    
                  ></b-form-textarea>
                </b-col>
              </b-row>

              <b-row class="mt-3 mb-3" v-show="!openTraining">
                <b-col>
                  <label for="description" class="form-label">Description</label>
                  <b-form-textarea
                    class="form-control"
                    size="sm"
                    v-model="description"
                    id="description"
                    rows="5"
                    no-resize
                     :disabled="
                        this.$store.state.auth.user.roles[0] !== 'ROLE_SALES' &&
                        this.$store.state.auth.user.roles[0] !== 'ROLE_SUPERADMIN' &&
                       
                        this.$store.state.auth.user.roles[0] !== 'ROLE_TRAINING'
                      "
                    
                  ></b-form-textarea>
                </b-col>
              </b-row>

              <b-row class="mt-3 mb-3" v-show="!openTraining">
                <div>
                  <label for="tags-basic">Etiquetas</label>
                  <b-form-tags
                    input-id="tags-basic"
                    v-model="etiquetas"
                    placeholder=""
                    rows="5"
                  ></b-form-tags>
                </div>
              </b-row>

              <b-row class="mt-5 mb-4" v-show="!openTraining">
                <b-col cols="2">
                  <label
                    style="font-weight: bold; font-size: 110%"
                    class="mb-"
                    for="itemSubcontratado"
                  >Subcontratado</label>
                </b-col>
                <b-col>
                  <input
                    :disabled="
                      this.$store.state.auth.user.roles[0] !== 'ROLE_SALES' &&
                      this.$store.state.auth.user.roles[0] !== 'ROLE_SUPERADMIN' &&
                      this.$store.state.auth.user.roles[0] !== 'ROLE_MANAGER' &&
                      this.$store.state.auth.user.roles[0] !== 'ROLE_TRAINING'
                    "
                    type="checkbox"
                    class="custom-checkbox"
                    v-model="itemSubcontratado"
                    @change="seleccionarCheckboxSubcontratado"
                  />
                </b-col>
              </b-row>

              <b-row class="mt-1 mb-5" v-show="itemSubcontratado == true">
                <b-row class="mt-5 mb-3">
                  <b-col cols="2">
                    <label for="numeroQuotation">Nº Quotation</label>
                  </b-col>
                  <b-col cols="2">
                    <b-form-input
                      size="sm"
                      v-model="numeroQuotation"
                      id="numeroQuotation"
                    ></b-form-input>
                  </b-col>
                </b-row>

                <b-col cols="3">
                  <label for="importeSubcontratacion">Importe Subcontratación</label>
                </b-col>
                <b-col cols="2">
                  <b-form-input
                    :disabled="!(
                      this.$store.state.auth.user.roles.includes('ROLE_SUPERADMIN') ||
                      this.$store.state.auth.user.roles.includes('ROLE_TRAINING')
                    ) && this.id !== ''"
                    size="sm"
                    v-model="importeSubcontratacion"
                    id="importeSubcontratacion"
                  />
                </b-col>
                <b-col cols="2">
                  <label for="archivoSubcontratacion" class="ml-2">Subir Archivo</label>
                </b-col>
                <b-col cols="3">
                  <b-form-file
                    size="sm"
                    v-model="archivoSubcontratacion"
                    placeholder="Fichero ..."
                  ></b-form-file>
                </b-col>
                <b-col cols="2">
                  <b-button
                    v-show="documento.length != 0"
                    variant="outline-primary"
                    class="actionButton"
                    @click="getFile()"
                  ><i class="fas fa-file 2x"></i></b-button>
                </b-col>
              </b-row>

              <b-card
                v-show="tipoServicio == 'TESTING'"
                style="background-color: rgb(247, 247, 247)"
                class="mt-4 mb-4"
              >
                <Ensayos ref="Ensayos" :importeItem="importeItem" class="mt-1 mb-1" />
              </b-card>

              <div v-show="tipoServicio != 'TESTING' && !openTraining">
                <strong style="font-size: 120%">Estimacion Horas Item</strong>

                <b-row class="mt-5 mb-3">
                  <form @submit.prevent="agregarConsultor">
                    <label class="mr-5">
                      Tipo de Consultor
                      <select class="ml-3" style="width: 120px" v-model="nuevoConsultor.tipo">
                        <option value="Senior">Senior</option>
                        <option value="Junior">Junior</option>
                        <option value="Becario">Becario</option>
                      </select>
                    </label>
                    <label class="mr-5">
                      Horas
                      <input
                        class="ml-3"
                        style="width: 60px; text: center"
                        v-model.number="nuevoConsultor.horas"
                        type="number"
                        step="0.1"
                        required
                      />
                    </label>
                    <button
                      :disabled="
                        this.$store.state.auth.user.roles[0] !== 'ROLE_SALES' &&
                        this.$store.state.auth.user.roles[0] !== 'ROLE_SUPERADMIN' &&
                        this.$store.state.auth.user.roles[0] !== 'ROLE_MANAGER' &&
                        this.$store.state.auth.user.roles[0] !== 'ROLE_TRAINING'
                      "
                      class="ml-5"
                      type="submit"
                    >
                      Añadir Horas
                    </button>
                  </form>
                </b-row>

                <b-row v-if="openTraining == false" class="mt-5 mb-3">
                  <b-col class="table-container">
                    <table class="tabla-consultores">
                      <thead>
                        <tr>
                          <th>Consultor</th>
                          <th>Horas Estimadas</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Senior</td>
                          <td>{{ horasEstimadasSenior }}</td>
                        </tr>
                        <tr>
                          <td>Junior</td>
                          <td>{{ horasEstimadasJunior }}</td>
                        </tr>
                        <tr>
                          <td>Becario</td>
                          <td>{{ horasEstimadasBecario }}</td>
                        </tr>
                        <tr>
                          <td><strong>Totales</strong></td>
                          <td><strong>{{ calcularTotalHoras() }}</strong></td>
                        </tr>
                      </tbody>
                    </table>
                  </b-col>
                </b-row>

                <b-row v-if="openTraining == false">
                  <b-col cols="2">
                    <label
                      class="mt-3 mb-3"
                      style="font-weight: bold; font-size: 113%"
                      for="consultoriaHoras"
                    >Consultoría Horas</label>
                  </b-col>
                  <b-col cols="1" class="mt-3 mb-3">
                    <input
                      type="checkbox"
                      class="custom-checkbox"
                      v-model="consultoriaHoras"
                      :disabled="
                        this.$store.state.auth.user.roles[0] !== 'ROLE_SALES' &&
                        this.$store.state.auth.user.roles[0] !== 'ROLE_SUPERADMIN' &&
                        this.$store.state.auth.user.roles[0] !== 'ROLE_MANAGER' &&
                        this.$store.state.auth.user.roles[0] !== 'ROLE_TRAINING'
                      "
                    />
                  </b-col>
                </b-row>

                <b-card
                  v-show="!openTraining"
                  style="background-color: rgb(247, 247, 247)"
                  class="mt-4 mb-4"
                >
                  <EquipoTrabajo
                    ref="equipotrabajo"
                    :consultoriaHoras="consultoriaHoras"
                    :consultoresProyecto="consultoresProyecto"
                    :importeItem="importeItem"
                    :numeroOferta="numeroOferta"
                    :numeroItem="numeroItem"
                    :horasTotalesEstimadas="horasEstimadasTotal"
                    :openTraining="openTraining"
                    :tipoProyecto="tipoProyecto"
                    :equipo-trabajo="equipoTrabajo"
                    @update-equipo="equipoTrabajo = $event"
                    class="mt-1 mb-1"
                  ></EquipoTrabajo>
                </b-card>

                <b-row v-if="openTraining == false" style="padding-top: 10px; padding-bottom: 10px">
                  <b-col cols="4">
                    <label for="gastosDesplazamientoIncludiosImporteItem">
                      Gastos Desplazamiento(Incluido en Oferta)
                    </label>
                    <b-form-input
                      class="form-control"
                      size="sm"
                      v-model="gastosDesplazamientoIncludiosImporteItem"
                      id="gastosDesplazamientoIncludiosImporteItem"
                      rows="1"
                      :disabled="
                        this.$store.state.auth.user.roles[0] !== 'ROLE_SALES' &&
                        this.$store.state.auth.user.roles[0] !== 'ROLE_SUPERADMIN' &&
                        this.$store.state.auth.user.roles[0] !== 'ROLE_MANAGER' &&
                        this.$store.state.auth.user.roles[0] !== 'ROLE_TRAINING'
                      "
                    ></b-form-input>
                  </b-col>
                </b-row>

                <b-row v-if="openTraining == false">
                  <b-col cols="1">
                    <label class="mt-3 mb-3" style="font-weight: bold" for="POC">POC</label>
                  </b-col>
                  <b-col cols="1" class="mt-3 mb-3">
                    <input
                      :disabled="this.$store.state.auth.user.roles[0] !== 'ROLE_SUPERADMIN'"
                      type="checkbox"
                      class="custom-checkbox"
                      v-model="poc"
                    />
                  </b-col>
                </b-row>

                <b-card
                  v-if="openTraining == false"
                  style="background-color: rgb(247, 247, 247)"
                  class="mt-4 mb-4"
                >
                  <AvanceItem
                    ref="avanceItem"
                    :cuasiPedido="cuasiPedido"
                    :equipoTrabajo="equipoTrabajo"
                    :importeItem="importeItem"
                    :horasEstimadasTotal="horasEstimadasTotal"
                    :estadoItem="estadoItem"
                    :parado="parado"
                    :itemFinalizado="itemFinalizado"
                    class="mt-1 mb-1"
                  ></AvanceItem>
                </b-card>
              </div>

              <b-card style="background-color: rgb(247, 247, 247)" class="mt-4 mb-4">
                <HitosFacturacion
                  ref="hitosfacturacion"
                  :avance="avance"
                  :importeItem="importeItem"
                  :propietarioNombre="propietarioNombre"
                  :cuasiPedido="cuasiPedido"
                  class="mt-1 mb-1"
                />
              </b-card>

              <b-row style="padding-top: 50px">
                <b-col cols="4" v-if="openTraining == false">
                  <label for="totalProvisionado">Total Provisionado</label>

                  <b-button
                    style="size: 0.8rem"
                    :disabled="
                      this.$store.state.auth.user.roles[0] !== 'ROLE_MANAGER' &&
                      this.$store.state.auth.user.roles[0] !== 'ROLE_SUPERADMIN' &&
                      this.$store.state.auth.user.roles[0] !== 'ROLE_FINANCE'
                    "
                    class="actionButton ml-3"
                    :variant="!observacionPrevision ? 'outline-primary' : 'outline-danger'"
                    @click="mostrarModalObservacion"
                  >
                    <i class="fas fa-comment-dots"></i>
                  </b-button>

                  <b-form-input
                    disabled
                    class="form-control"
                    size="sm"
                    v-model="totalProvisionado"
                    id="totalProvisionado"
                    rows="1"
                  ></b-form-input>
                </b-col>

                <b-col cols="4">
                  <label for="totalFacturado">Total Facturado</label>
                  <b-form-input
                    :disabled="
                      this.$store.state.auth.user.roles[0] !== 'ROLE_FINANCE' &&
                      this.$store.state.auth.user.roles[0] !== 'ROLE_SUPERADMIN'
                    "
                    class="form-control"
                    size="sm"
                    v-model="totalFacturado"
                    id="totalFacturado"
                    rows="1"
                  ></b-form-input>
                </b-col>
              </b-row>

              <b-row>
                <b-col cols="3" class="mt-4 mb-3">
                  <label style="font-weight: bold" for="partNumber">Revisión del Informe</label>
                </b-col>
              </b-row>

              <b-row class="mt-3 mb-3">
                <b-col cols="8">
                  <label for="type" class="form-label">Consultor</label>
                  <b-form-select
                    v-model="consultor"
                    size="sm"
                    style="font-size: 90%; background: rgb(228, 245, 229)"
                  >
                    <option v-for="co in empleadosFiltradosOrdenados" :value="co" :key="co.id">
                      {{ co.nombre }}
                    </option>
                  </b-form-select>
                </b-col>

                <b-col>
                  <label>Tipo de Revisión</label>
                  <b-form-select
                    size="sm"
                    v-model="tipoRevision"
                    style="font-size: 90%; background: rgb(228, 245, 229)"
                  >
                    <option value=""></option>
                    <option v-show="tipoServicio != 'TESTING'" value="Senior">Senior</option>
                    <option v-show="tipoServicio != 'TESTING'" value="Junior">Junior</option>
                    <option v-show="tipoServicio == 'TESTING'" value="Ensayo">Ensayo</option>
                  </b-form-select>
                </b-col>
              </b-row>

              <b-row class="mb-4">
                <b-col>
                  <label for="calificacionRevision" class="form-label">Calificación de la Revisión</label>
                  <b-form-select
                    size="sm"
                    v-model="calificacionRevision"
                    style="font-size: 90%; background: rgb(228, 245, 229)"
                  >
                    <option value=""></option>
                    <option v-show="tipoServicio != 'TESTING'" value="Sin Revisión">Sin Revisión</option>
                    <option v-show="tipoServicio != 'TESTING'" value="NoAplica(Saqratex)">NO aplica (Formación/Saqratex/consultoría por horas)</option>
                    <option v-show="tipoServicio != 'TESTING'" value="SinModificacionesSignificativas">Sin Modificaciones Significativas</option>
                    <option v-show="tipoServicio != 'TESTING'" value="ConModificacionesLeves">Con Modificaciones Leves</option>
                    <option v-show="tipoServicio != 'TESTING'" value="ConModificacionesConceptuales">Con Modificaciones Conceptuales</option>
                    <option v-show="tipoServicio == 'TESTING'" value="Ok">Ensayo OK</option>
                    <option v-show="tipoServicio == 'TESTING'" value="No OK">Enasyo No OK</option>
                  </b-form-select>
                </b-col>
              </b-row>

              <b-row style="padding-top: 50px">
                <b-col cols="6">
                  <label for="contacto">eMail del Contacto Cliente Encuesta</label>
                  <b-form-input
                    style="font-size: 90%; background: rgb(228, 245, 229)"
                    class="form-control"
                    size="sm"
                    v-model="contacto"
                    id="contacto"
                    rows="1"
                    placeholder="Introducir dirección email de la persona de contacto dal cliente"
                  ></b-form-input>
                  <p
                    v-if="!emailValido && contacto !== ''"
                    style="font-size: 12px; color: rgb(8, 92, 19)"
                    class="error-message"
                  >
                    Introduce Formato de email
                  </p>
                </b-col>
              </b-row>

              <b-row style="padding-top: 20px">
                <b-col cols="2">
                  <label class="mt-3 mb-3" for="itemFacturado">Item Facturado</label>
                </b-col>
                <b-col cols="1" class="mt-3 mb-3">
                  <input
                    type="checkbox"
                    class="custom-checkbox"
                    v-model="itemFacturado"
                    @change="seleccionarCheckboxFacturado"
                  />
                </b-col>
              </b-row>

              <b-row>
                <b-col cols="2">
                  <label class="mt-3 mb-3" for="itemFinalizado" strong style="background: rgb(228, 245, 229)">Item Finalizado</label>
                </b-col>
                <b-col cols="1" class="mt-3 mb-3">
                  <input
                    type="checkbox"
                    class="custom-checkbox"
                    v-model="itemFinalizado"
                    :disabled="isCheckboxDisabled"
                    @change="seleccionarCheckboxFinalizado"
                  />
                </b-col>
                <b-col cols="2">
                  <label class="mt-3 mb-3" for="enviarEncuesta" strong style="background: rgb(228, 245, 229)">Enviar Encuesta</label>
                </b-col>
                <b-col cols="1" class="mt-3 mb-3">
                  <input
                    type="checkbox"
                    class="custom-checkbox"
                    v-model="enviarEncuesta"
                    @change="seleccionarCheckboxEnviarEncuesta"
                  />
                </b-col>

                <div
                  v-if="
                    (this.consultor === '' &&
                      this.calificacionRevision !== 'NoAplica(Saqratex)' &&
                      this.calificacionRevision !== 'Sin Revisión') ||
                    (this.calificacionRevision === '' &&
                      this.calificacionRevision !== 'NoAplica(Saqratex)' &&
                      this.calificacionRevision !== 'Sin Revisión') ||
                    (this.tipoRevision === '' &&
                      this.calificacionRevision !== 'NoAplica(Saqratex)' &&
                      this.calificacionRevision !== 'Sin Revisión') ||
                    (this.$refs.hitosfacturacion &&
                      this.$refs.hitosfacturacion.todoFacturar === false) ||
                    (this.$refs.equipotrabajo &&
                      this.$refs.equipotrabajo.todoFacturarMix === false)
                  "
                  class="text-danger"
                >
                  {{ messageToShow() }}
                </div>
              </b-row>

              <b-row class="mt-5">
                <b-col cols="2" class="ml-3 mt-2" v-show="!openTraining">
                  <b-form-checkbox v-model="proyectoReferencias" name="check-button" switch>
                    Referencias
                  </b-form-checkbox>
                </b-col>
              </b-row>

              <div class="col-sm mt-5 mr-4 d-grid gap-2 d-md-flex justify-content-md-end">
                <b-button
                  variant="outline-danger"
                  class="actionButton"
                  @click="closeItem()"
                ><i class="far fa-times-circle mr-1"></i>Cancel</b-button>

                <b-button
                  :disabled="tipoProyecto == '' || tipoServicio == '' || numeroItem == '' || edicionBloqueada"
                  variant="success"
                  class="actionButton"
                  @click="addItem()"
                >Save Item</b-button>
              </div>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </b-modal>
 <b-modal
                id="modal-observacionesProvisionado"
                title="Observaciones"
                ok-variant="primary"
                ok-title="Guardar"
                cancel-title="Cancelar"
                footer-class="p-2"
                :centered="true"
                @ok="guardarObservacion"
              >
                <label for="modal-observacionesProvisionado" class="form-label"
                  >Observaciones</label
                >
                <b-form-textarea
                  id="modal-observacionesProvisionado"
                  v-model="observacionPrevision"
                  rows="4"
                />
              </b-modal>

    <b-modal
      id="modal-observaciones-item"
      title="Observaciones"
      ok-variant="primary"
      ok-title="Guardar"
      cancel-title="Cancelar"
      footer-class="p-2"
      :centered="true"
      @ok="guardarObservacionItem"
    >
      <label for="observacionItem" class="form-label">Observaciones</label>
      <b-form-textarea v-model="observacionItem" />
    </b-modal>
  </div>
</template>

<script>
import crudService from "@/services/crud.service";
import { api1, api2 } from "@/lib/http";

import HitosFacturacion from "./HitosFacturacionComponent.vue";
import Ensayos from "./EnsayoComponent.vue";
import AvanceItem from "./AvanceItemComponent.vue";
import HitosEntregaItem from "./HitosEntregaItemComponent.vue";
import EquipoTrabajo from "./EquipoTrabajoComponent.vue";
import VueJsonPretty from "vue-json-pretty";
import "vue-json-pretty/lib/styles.css";
import Proyecto from "../views/ModalProyectos.vue";
import Clientes from "../views/Clientes.vue";
import { state } from "@/event-bus";
//import { apiEmailEncuesta } from "@/lib/http";

export default {
  props: {
    optionsSectores: { type: Array, required: true },
    numeroOferta: { type: String, required: true },
    propietarioNombre: { type: String, required: true },
    openTraining: { type: Boolean, required: true, default: false },
    guardarProyecto: { type: Function, required: true },
    crearCurso: { type: Boolean, required: true, default: true },
     edicionBloqueada: { type: Boolean, default: false },
  },
  name: "Item",
  data() {
    return {
       modalAbierta: false,
      observacionItem: "",
      item_observacion: { observacionItem: "" },
      infoModalProyecto: { id: "info-modal-proyecto", title: "", content: "" },
      proyectoReferencias: true,
      consultores: [
        { id: 1, tipo: "Senior", horas: 0.0 },
        { id: 2, tipo: "Junior", horas: 0.0 },
        { id: 3, tipo: "Becario", horas: 0.0 },
      ],
      nuevoConsultor: { tipo: "", horas: 0.0 },
      horasEstimadasTotal: 0.0,
      horasEstimadasSenior: 0.0,
      horasEstimadasJunior: 0.0,
      horasEstimadasBecario: 0.0,
      provisionado_observacion: { observacionPrevision: "" },
      observacionPrevision: "",
      skipCloseConfirm: false,

      // Part fields
      id: "",
      numeroPedido: "",
      numeroItem: "",
      importeItem: 0,
      tipoProyecto: "",
      itemProyecto: "",
      tipoServicio: "",
      consultoresProyecto: [],
      fechaEntrega: "",
      informacionFaseOferta: "",
      descripcion: "",
      textoCurriculum: "",
      description: "",
      etiquetas: [],
      consultor: null,
      importeSubcontratacion: 0,
      itemSubcontratado: false,
      textoCv: "",
      enviarEncuesta: true,
      equipoTrabajoItem: [],
      avance: [],
      facturacion: [],
      tipoRevision: "",
      calificacionRevision: "",
      contacto: "",
      itemFacturado: false,
      itemFinalizado: false,

      // array sincronizado con EquipoTrabajo
      equipoTrabajo: [],

      itemList: [],
      fechaPedido: " ",
      rowIndex: "",
      rowValue: "",
      gastosDesplazamientoIncludiosImporteItem: 0,
      totalFacturado: 0,
      totalProvisionado: 0,
      horasTotalesEstimadas: 0,
      horasTotalesRealizadas: 0,
      desviacionHorasItem: 0,
      gastoDesplazamientoCosteChk: false,
      gastoCertificadoChk: false,
      importeConsultoriaHoras: 0,
      archivoSubcontratacion: [],
      documento: [],
      cliente: null,
      clientes: [],
      parado: false,
      idCursoOrigen: null,

      // navegaciones
      itemAnyadir: "",
      encuestaEnviadaItem: false,
      cuasiPedido: false,
      edit: false,
      meses: [],
      importeMes: [],
      importeMesFormato: [],
      previsionMes: [],
      previsionImporte: [],
      prevision: [],
      fechaPrimerContactoItem: "",
      numeroQuotation: "",
      poc: false,
      informacionCambioFechaEntrega: "",
      fechaEntregaActualizada: "",
      consultoriaHoras: false,
      cerrarModal: false,
      emailValido: true,
      estadoItem: false,
      abiertoDesdeCurso: false,
      cif: "",
      sector: "",
      fechaVisita: "",
      infoModalCliente: { id: "info-modal-cliente", title: "", content: "" },
    };
  },

  methods: {
async sendEncuestaEmail() {
  // 1) Ya se ha enviado antes
  if (this.encuestaEnviadaItem) {
    alert("La encuesta ya fue enviada para este ítem. No se volverá a enviar.");
    return;
  }

  // 2) Opción enviarEncuesta desmarcada
  if (!this.enviarEncuesta) {
    alert("Has desmarcado 'Enviar Encuesta', no se envía el email de la encuesta.");
    return;
  }

  // 3) Email vacío
  if (!this.contacto || this.contacto.trim() === "") {
    alert("Para enviar la encuesta tienes que rellenar el email de contacto del cliente.");
    // Por si venimos de marcar Item Finalizado
    this.itemFinalizado = false;
    return;
  }

  // 4) Formato de email incorrecto
  const emailLimpio = this.contacto.trim();
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(emailLimpio)) {
    alert("El email de contacto no tiene un formato válido.");
    // Revertimos el finalizado si venimos de ahí
    this.itemFinalizado = false;
    event.target.checked = false;
    return;
  }

  // ✅ Ahora NO construimos HTML aquí. Lo hace el backend.
  const payloadEnvio = {
    numeroOferta: this.numeroOferta,
    numeroItem: this.numeroItem,
    emailCliente: emailLimpio,
  };

    try {
      // Enviamos email (el backend construye subject + HTML)
      await api1.post("/api/dekra-projects/v204/encuestaCliente/enviarEncuesta", payloadEnvio);

      // --- NUEVO: Encuesta Subcontrata ---
      if (this.itemSubcontratado) {
        try {
          await api1.post("/api/dekra-projects/v204/encuestaSubcontrata/enviar", {
            numeroOferta: this.numeroOferta,
            numeroItem: this.numeroItem
          });
        } catch (errSub) {

          console.error("Error enviando encuesta subcontrata:", errSub);
          // No bloqueamos el flujo principal si falla esta
        }
      }
      // ------------------------------------

      // Registramos fecha de envío en backend (se queda igual)

    await api1.post("/api/dekra-projects/v204/encuestaCliente/registrarEnvio", {
      numeroOferta: this.numeroOferta,
      numeroItem: this.numeroItem,
      emailCliente: emailLimpio,
    });

    this.encuestaEnviadaItem = true;

    try {
      await this.addItemSilent?.();
    } catch (e) {
      console.warn("Email enviado y fecha registrada, pero fallo guardando el ítem", e);
    }

    alert("Se ha enviado la encuesta al contacto del cliente.");
  } catch (error) {
    console.error("Error enviando email o registrando encuesta:", error);
    this.itemFinalizado = false;
    alert("No se pudo enviar la encuesta al cliente.");
  }
}

,

  
      isItemModalOpen() { return this.modalAbierta === true; },
  // tu buildItemFromForm() ya existe

     async closeSilently() {
  this.cerrarModal = true;

  // cierra la modal por API y evento
  this.$bvModal?.hide('itemconfiguration');
  this.$root.$emit('bv::hide::modal', 'itemconfiguration');

  // limpia el estado igual que closeItem
  this.rowValue = null;
  this.rowIndex = null;
  this.resetEditModal?.();
  this.reset?.();

  await this.$nextTick();
  },
    buildItemFromForm() {
      // Copia 1:1 de tu "base" en addItem()
      const ensayo = this.tipoServicio === "TESTING"
        ? this.$refs.Ensayos?.cargarEnsayo?.()
        : undefined;

      const base = {
        numeroItem: this.numeroItem,
        numeroPedido: this.numeroPedido,
        importeItem: this.$parseDecimal(this.importeItem),
        equipoTrabajo: this.openTraining ? [] : this.equipoTrabajo,
        tipoProyecto: this.tipoProyecto,
        tipoServicio: this.tipoServicio,
        fechaEntrega: this.fechaEntrega,
        informacionFaseOferta: this.informacionFaseOferta,
        descripcion: this.descripcion,
        fechaPedido: this.fechaPedido,
        textoCv: this.textoCv,
        etiquetas: this.etiquetas,
        itemSubcontratado: this.itemSubcontratado,
        avance: this.openTraining ? [] : (this.$refs.avanceItem?.avance || []),
        facturacion: this.$refs.hitosfacturacion?.hitosFacturacion || [],
        tipoRevision: this.tipoRevision,
        calificacionRevision: this.calificacionRevision,
        contacto: this.contacto,
        itemFacturado: this.itemFacturado,
        itemFinalizado: this.itemFinalizado,
        importeSubcontratacion: this.$parseDecimal(this.importeSubcontratacion),
        documentos: this.documento,
        consultor: this.consultor,
        horasEstimadasTotal: this.openTraining ? 0 : this.$parseDecimal(this.horasEstimadasTotal),
        horasEstimadasSenior: this.openTraining ? 0 : this.$parseDecimal(this.horasEstimadasSenior),
        horasEstimadasJunior: this.openTraining ? 0 : this.$parseDecimal(this.horasEstimadasJunior),
        horasEstimadasBecario: this.openTraining ? 0 : this.$parseDecimal(this.horasEstimadasBecario),
        gastosDesplazamientoIncludiosImporteItem: this.$parseDecimal(this.gastosDesplazamientoIncludiosImporteItem),
        totalFacturado: this.$parseDecimal(this.totalFacturado),
        totalProvisionado: this.$parseDecimal(this.totalProvisionado),
        horasTotalesEstimadas: this.openTraining ? 0 : (this.$refs.equipotrabajo?.horasTotalesEstimadas ?? 0),
        horasTotalesRealizadas: this.openTraining ? 0 : (this.$refs.equipotrabajo?.horasTotalesRealizadas ?? 0),
        desviacionHorasItem: this.openTraining ? 0 : (this.$refs.equipotrabajo?.desviacionHorasItem ?? 0),
        gastoDesplazamientoCosteChk: this.$refs.hitosfacturacion?.gastoDesplazamientoCosteCheck ?? false,
        gastoCertificadoChk: this.$refs.hitosfacturacion?.gastoCertificadoCheck ?? false,
        costeBonificaiconChk: this.$refs.hitosfacturacion?.costeBonificacionCheck ?? false,
        description: this.description,
        proyectoReferencias: this.openTraining ? false : this.proyectoReferencias,
        enviarEncuesta: this.enviarEncuesta,
        encuestaEnviadaItem: this.encuestaEnviadaItem,
        cuasiPedido: this.cuasiPedido,
        prevision: this.prevision,
        fechaPrimerContactoItem: this.fechaPrimerContactoItem,
        numeroQuotation: this.numeroQuotation,
        poc: this.poc,
        informacionCambioFechaEntrega: this.informacionCambioFechaEntrega,
        fechaEntregaActualizada: this.fechaEntregaActualizada,
        consultoriaHoras: this.consultoriaHoras,
        cliente: this.openTraining ? this.cliente : null,
        cif: this.openTraining ? this.cif : "",
        sector: this.sector,
        parado: this.parado,
        observacionPrevision: this.observacionPrevision,
        fechaVisita: this.fechaVisita,
        observacionItem: this.observacionItem,
        estadoItem: this.estadoItem,
      };

      if (typeof ensayo !== "undefined") base.ensayo = ensayo;
      if (this.id !== "") base.id = this.id;

      return base;
    },

    // Inserta/actualiza en itemList (tal y como ya haces con addLineItem)
    upsertItemInList(updated) {
      this.itemProyecto = updated;
      this.addLineItem(); // tu método actual que mete/actualiza por id
    },

    // 🔇 Guardado silencioso para el autosave (sin UI ni navegación)
    async addItemSilent() {
      try {
        // 1) Evitar bloquear por email inválido: si enviarEncuesta=true y no es válido → la desactivamos.
        this.validarFormatoEmail(this.contacto);
        if (!this.emailValido && this.enviarEncuesta) {
          this.enviarEncuesta = false;
        }

        // 2) NO subimos fichero en autosave (evita esperas/diálogos). Si quieres subirlo, llama this.submitFile()
        // if (this.archivoSubcontratacion.length) await this.submitFile();

        // 3) Construir item y volcar a itemList
        const updated = this.buildItemFromForm();
        this.upsertItemInList(updated);

        // 4) Persistir en backend
        const ok = await this.actualizarItem(); // reutiliza tu método
        if (!ok) return false;

        // 5) Cerrar modal si estaba abierta, pero sin routing
        const modalRef = this.$refs?.itemEditModal;
        if (modalRef && modalRef.visible) modalRef.hide();

        // 6) Emitir el mismo evento que ya usas para sincronizar arriba si quieres
        this.$emit('item-saved', updated);

        return true;
      } catch (e) {
        console.error("addItemSilent failed:", e);
        return false;
      }
    },
       async guardarObservacion() {
       }
       ,
    async guardarObservacionItem() {
      this.$set(this.item_observacion, "observacionItem", this.observacionItem);
      const id = this.item_observacion?.id || this.id;
      if (id) {
        try {
          const current = this.itemList.find(i => i.id === id) || {};
          const payload = { ...current, id, observacionItem: this.observacionItem };
          await this.guardarItemSilent(payload);
          this.$bvToast.toast("Observación guardada", { title: "OK", variant: "success", solid: true });
          this.$nextTick(() => this.$bvModal.hide("modal-observaciones-item"));
        } catch (e) {
          this.$bvToast.toast("No se pudo guardar la observación", { title: "Error", variant: "danger", solid: true });
        }
      } else {
        this.$bvToast.toast("Se guardará al guardar el ítem", { title: "Info", variant: "info", solid: true });
      }
    },

    abrirObservacion(item) {
      this.item_observacion = item;
      this.observacionItem = item?.observacionItem || "";
    },

    // --- NAVEGAR AL CURSO DESDE EL NUMERO DE ITEM (modal) ---
    async irAProyectoYItem() {
      if (
        this.openTraining === false &&
        ["TRAINING", "OPENTRAINING", "ELEARNING"].includes(this.tipoServicio)
      ) {
        const codigo = `${this.numeroOferta}/${this.numeroItem}`;
        if (!this.numeroOferta || !this.numeroItem) {
          this.$bvModal.msgBoxOk("No se encontró ningún curso con ese código de proyecto.", {
            title: "Aviso",
            size: "sm",
            buttonSize: "sm",
            okVariant: "primary",
            headerClass: "p-2 border-bottom-0",
            footerClass: "p-2 border-top-0",
            centered: true,
          });
          return;
        }

        if (document && document.activeElement) document.activeElement.blur();
        await this.$nextTick();

        const itemPlano = {
          id: this.id || undefined,
          numeroItem: this.numeroItem,
          numeroPedido: this.numeroPedido,
          importeItem: this.$parseDecimal(this.importeItem),
          equipoTrabajo: this.openTraining ? [] : (this.equipoTrabajo || []),
          tipoProyecto: this.tipoProyecto,
          tipoServicio: this.tipoServicio,
          fechaEntrega: this.fechaEntrega,
          informacionFaseOferta: this.informacionFaseOferta,
          descripcion: this.descripcion,
          fechaPedido: this.fechaPedido,
          textoCv: this.textoCv,
          etiquetas: this.etiquetas,
          itemSubcontratado: this.itemSubcontratado,
          tipoRevision: this.tipoRevision,
          calificacionRevision: this.calificacionRevision,
          contacto: this.contacto,
          itemFacturado: this.itemFacturado,
          itemFinalizado: this.itemFinalizado,
          importeSubcontratacion: this.$parseDecimal(this.importeSubcontratacion),
          documentos: this.documento,
          consultor: this.consultor,
          horasEstimadasTotal: this.openTraining ? 0 : this.$parseDecimal(this.horasEstimadasTotal),
          horasEstimadasSenior: this.openTraining ? 0 : this.$parseDecimal(this.horasEstimadasSenior),
          horasEstimadasJunior: this.openTraining ? 0 : this.$parseDecimal(this.horasEstimadasJunior),
          horasEstimadasBecario: this.openTraining ? 0 : this.$parseDecimal(this.horasEstimadasBecario),
          gastosDesplazamientoIncludiosImporteItem: this.$parseDecimal(this.gastosDesplazamientoIncludiosImporteItem),
          totalFacturado: this.$parseDecimal(this.totalFacturado),
          totalProvisionado: this.$parseDecimal(this.totalProvisionado),
          horasTotalesEstimadas: this.openTraining ? 0 : (this.$refs.equipotrabajo?.horasTotalesEstimadas ?? 0),
          horasTotalesRealizadas: this.openTraining ? 0 : (this.$refs.equipotrabajo?.horasTotalesRealizadas ?? 0),
          desviacionHorasItem: this.openTraining ? 0 : (this.$refs.equipotrabajo?.desviacionHorasItem ?? 0),
          gastoDesplazamientoCosteChk: this.$refs.hitosfacturacion?.gastoDesplazamientoCosteCheck ?? false,
          gastoCertificadoChk: this.$refs.hitosfacturacion?.gastoCertificadoCheck ?? false,
          costeBonificaiconChk: this.$refs.hitosfacturacion?.costeBonificacionCheck ?? false,
          description: this.description,
          proyectoReferencias: this.openTraining ? false : this.proyectoReferencias,
          enviarEncuesta: this.enviarEncuesta,
          encuestaEnviadaItem: this.encuestaEnviadaItem,
          cuasiPedido: this.cuasiPedido,
          prevision: this.prevision,
          fechaPrimerContactoItem: this.fechaPrimerContactoItem,
          numeroQuotation: this.numeroQuotation,
          poc: this.poc,
          informacionCambioFechaEntrega: this.informacionCambioFechaEntrega,
          fechaEntregaActualizada: this.fechaEntregaActualizada,
          consultoriaHoras: this.consultoriaHoras,
          cliente: this.openTraining ? this.cliente : null,
          cif: this.openTraining ? this.cif : "",
          sector: this.sector,
          parado: this.parado,
          observacionPrevision: this.observacionPrevision,
          fechaVisita: this.fechaVisita,
          numeroOferta: this.numeroOferta,
          avance: this.openTraining ? [] : (this.$refs.avanceItem?.avance || []),
          facturacion: this.$refs.hitosfacturacion?.hitosFacturacion || [],
          observacionItem: this.observacionItem,
        estadoItem: this.estadoItem,
        };

        this.skipCloseConfirm = true;
        this.$root.$emit("bv::hide::modal", "itemconfiguration");

        try {
          await this.guardarProyecto();
          const savedItem = await this.guardarItemSilent(itemPlano);
          this.$emit("item-saved", savedItem);

          const cursoId = await this.syncCursoByCodigo(
            codigo,
            itemPlano.equipoTrabajo,
            itemPlano.tipoServicio
          );

          if (cursoId) {
            state.deboVolverACursoItem = true;
            this.$router.push(`/curso/${cursoId}`);
          } else {
            this.$bvModal.msgBoxOk("No se encontró ningún curso con ese código de proyecto.", {
              title: "Aviso",
              size: "sm",
              buttonSize: "sm",
              okVariant: "primary",
              headerClass: "p-2 border-bottom-0",
              footerClass: "p-2 border-top-0",
              centered: true,
            });
          }
        } catch (error) {
          console.error("Error guardando item o sincronizando curso:", error);
          this.$bvToast.toast("Ocurrió un error guardando y abriendo el curso.", {
            title: "Error",
            variant: "danger",
            solid: true,
            autoHideDelay: 8000,
          });
        }
      }
    },

    // --- NAVEGAR AL CURSO DESDE EL BOTON DE LA TABLA ---
    async irAProyectoYItem2(item) {
      if (
        this.openTraining === false &&
        ["TRAINING", "OPENTRAINING", "ELEARNING"].includes(item.tipoServicio)
      ) {
        const codigo = `${this.numeroOferta}/${item.numeroItem}`;
        if (!codigo) {
          this.$bvModal.msgBoxOk("No se encontró ningún curso con ese código de proyecto.", {
            title: "Aviso",
            size: "sm",
            buttonSize: "sm",
            okVariant: "primary",
            headerClass: "p-2 border-bottom-0",
            footerClass: "p-2 border-top-0",
            centered: true,
          });
          return;
        }
        this.skipCloseConfirm = true;
        this.$root.$emit("bv::hide::modal", "itemconfiguration");

        try {
          await this.guardarProyecto();
          await this.guardarItemSilent(item);

          const cursoId = await this.syncCursoByCodigo(
            codigo,
            item.equipoTrabajo,
            item.tipoServicio
          );

          if (cursoId) {
            state.deboVolverACursoItem = true;
            this.$router.push(`/curso/${cursoId}`);
          } else {
            this.$bvModal.msgBoxOk("No se encontró ningún curso con ese código de proyecto.", {
              title: "Aviso",
              size: "sm",
              buttonSize: "sm",
              okVariant: "primary",
              headerClass: "p-2 border-bottom-0",
              footerClass: "p-2 border-top-0",
              centered: true,
            });
          }
        } catch (error) {
          console.error("Error al guardar/sincronizar y abrir el curso:", error);
          this.$bvToast.toast("Ocurrió un error al abrir el curso.", {
            title: "Error",
            variant: "danger",
            solid: true,
          });
        }
      } else {
        this.$emit("ir-a-proyecto-y-item");
      }
    },

    // --- SAVE SILENCIOSO (acepta item externo o toma del modal) ---
    async guardarItemSilent(payload) {
      const url = "/api/dekra-projects/v204/item";
      let body = payload;

      if (payload.id) {
        // Rehidrata
        const { data: current } = await api1.get(`/api/dekra-projects/v204/Item/${payload.id}`);
        body = { ...(current || {}), ...(payload || {}) };

        // ✅ Preserva ENSAYO si es TESTING y no se envió en payload
        const traeEnsayo = Object.prototype.hasOwnProperty.call(payload, "ensayo");
        if (
          body?.tipoServicio === "TESTING" &&
          !traeEnsayo &&
          current &&
          Object.prototype.hasOwnProperty.call(current, "ensayo")
        ) {
          body.ensayo = current.ensayo;
        }
      }

      const method = payload.id ? "put" : "post";
      const { data } = await api1[method](url, body);

      const id = data?.id ?? payload.id ?? this.id;
      if (id) this.id = id;

      let savedFull = { ...body, ...(data || {}), id };
      const respuestaParcial = !data || Object.keys(data).length < 10;
      if (respuestaParcial && id) {
        const { data: full } = await api1.get(`/api/dekra-projects/v204/Item/${id}`);
        savedFull = { ...savedFull, ...(full || {}) };
      }

      return savedFull;
    },

    buildFormadoresFromEquipo(equipo = this.equipoTrabajo || []) {
      const externos = new Set();
      const internos = new Set();
      for (const p of equipo) {
        const id = p?.consultorNombre?.id;
        if (!id) continue;
        const esExterno = p?.consultorNombre?.externo === true;
        (esExterno ? externos : internos).add(id);
      }
      return {
        idFormadorExterno: Array.from(externos),
        idFormadorInterno: Array.from(internos),
      };
    },

    async syncCursoByCodigo(codigo, equipo, tipoServicio) {
      const resp = await api2.get("curso", {
        params: { "page-number": 0, "page-size": 1, "codigoProyecto-eq": codigo },
      });
      const curso = resp?.data?.content?.[0];
      if (!curso) return null;

      const { idFormadorExterno, idFormadorInterno } = this.buildFormadoresFromEquipo(equipo);
      curso.idFormadorExterno = idFormadorExterno;
      curso.idFormadorInterno = idFormadorInterno;
      curso.tipoFormacion = tipoServicio;

      await crudService.put("curso", curso);
      return curso.id;
    },

    async syncCursoConEquipoTrabajo(cursoId) {
      const externos = new Set();
      const internos = new Set();

      for (const p of this.equipoTrabajo || []) {
        const id = p?.consultorNombre?.id;
        if (!id) continue;
        const esExterno = p?.consultorNombre?.externo === true;
        (esExterno ? externos : internos).add(id);
      }

      const { data: curso } = await crudService.get(`curso/${cursoId}`);
      curso.idFormadorExterno = Array.from(externos);
      curso.idFormadorInterno = Array.from(internos);
      curso.tipoFormacion = this.tipoServicio;
      await crudService.put("curso", curso);
    },

    abrirModalConItem(itemCurso) {
      this.abiertoDesdeCurso = true;
      this.rowValue = itemCurso;
      this.edit = true;

      // Copiar arrays / props
      this.optionsSectores = itemCurso.optionsSectores || [];
      this.numeroOferta = itemCurso.numeroOferta || "";
      this.propietarioNombre = itemCurso.propietarioNombre || "";
      this.openTraining = itemCurso.openTraining || false;

      // sincronizados
      this.equipoTrabajo = itemCurso.equipoTrabajo || [];
      this.avance = itemCurso.avance || [];
      this.facturacion = itemCurso.facturacion || [];
      this.prevision = itemCurso.prevision || [];

      // Campos
      this.id = itemCurso.id;
      this.numeroItem = itemCurso.numeroItem;
      this.numeroQuotation = itemCurso.numeroQuotation;
      this.importeItem = itemCurso.importeItem;
      this.numeroPedido = itemCurso.numeroPedido;
      this.tipoProyecto = itemCurso.tipoProyecto;
      this.tipoServicio = itemCurso.tipoServicio;
      this.fechaPedido = itemCurso.fechaPedido;
      this.fechaEntrega = itemCurso.fechaEntrega;
      this.informacionFaseOferta = itemCurso.informacionFaseOferta;
      this.descripcion = itemCurso.descripcion;
      this.textoCv = itemCurso.textoCv;
      this.informacionCambioFechaEntrega = itemCurso.informacionCambioFechaEntrega;
      this.etiquetas = itemCurso.etiquetas || [];
      this.consultoriaHoras = itemCurso.consultoriaHoras;
      this.fechaEntregaActualizada = itemCurso.fechaEntregaActualizada;
      this.itemSubcontratado = itemCurso.itemSubcontratado;
      this.gastosDesplazamientoIncludiosImporteItem = itemCurso.gastosDesplazamientoIncludiosImporteItem;
      this.totalFacturado = itemCurso.totalFacturado;
      this.totalProvisionado = itemCurso.totalProvisionado;
      this.tipoRevision = itemCurso.tipoRevision;
      this.calificacionRevision = itemCurso.calificacionRevision;
      this.contacto = itemCurso.contacto;
      this.itemFacturado = itemCurso.itemFacturado;
      this.itemFinalizado = itemCurso.itemFinalizado;
      this.poc = itemCurso.poc;
      this.importeSubcontratacion = itemCurso.importeSubcontratacion;
      this.documento = itemCurso.documentos || [];
      this.consultor = itemCurso.consultor;
      this.horasEstimadasTotal = itemCurso.horasEstimadasTotal || 0;
      this.horasEstimadasSenior = itemCurso.horasEstimadasSenior || 0;
      this.horasEstimadasJunior = itemCurso.horasEstimadasJunior || 0;
      this.horasEstimadasBecario = itemCurso.horasEstimadasBecario || 0;
      this.description = itemCurso.description;
      this.proyectoReferencias = itemCurso.proyectoReferencias;
      this.enviarEncuesta = itemCurso.enviarEncuesta;
      this.encuestaEnviadaItem = itemCurso.encuestaEnviadaItem;
      this.cuasiPedido = itemCurso.cuasiPedido;
      this.fechaPrimerContactoItem = itemCurso.fechaPrimerContactoItem;
      this.estadoItem = itemCurso.estadoItem;
      this.cliente = this.openTraining ? itemCurso.cliente || {} : null;
      this.cif = this.openTraining ? itemCurso.cif || "" : "";
      this.sector = itemCurso.sector;
      this.fechaVisita = itemCurso.fechaVisita;
      this.parado = itemCurso.parado;
      this.observacionPrevision = itemCurso.observacionPrevision;
      this.observacionItem = itemCurso.observacionItem;

      this.edit = true;

      this.$nextTick(() => {
        if (this.$refs.avanceItem && !this.openTraining) {
          this.$refs.avanceItem.avance = itemCurso.avance ? [...itemCurso.avance] : [];
        }
        if (this.$refs.hitosEntregaItem) {
          this.$refs.hitosEntregaItem.hitoEntregas = itemCurso.hitoEntregas ? [...itemCurso.hitoEntregas] : [];
        }
        if (this.$refs.hitosfacturacion) {
          this.$refs.hitosfacturacion.hitosFacturacion = itemCurso.facturacion || [];
        }
        if (this.$refs.Ensayos && this.tipoServicio === "TESTING") {
          this.$refs.Ensayos.loadItemEnsayo(itemCurso.ensayo);
        }
      });

      this.$bvModal.show("itemconfiguration");
    },

    mostrarModalObservacion() {
      this.$bvModal.show("modal-observacionesProvisionado");
    },
    modalCliente(button) {
      this.$root.$emit("bv::show::modal", this.infoModalCliente.id, button);
    },
    updateCIF() {
      this.cif = this.cliente ? this.cliente.cif : "";
    },
    async cargarClientes() {
      try {
        const response = await api1.get("/api/dekra/v204/cliente");
        this.clientes = response.data;
      } catch (error) {
        console.error("Error loading clientes", error);
      }
    },
    handleClientSelected(client) {
      // Asegurarnos de que el cliente esté en la lista local
      if (this.clientes && !this.clientes.find(c => c.id === client.id)) {
        this.clientes.push(client);
      }
      this.cliente = client;
      this.cif = client.cif;
      this.$root.$emit('bv::hide::modal', this.infoModalCliente.id);
      this.$bvToast.toast(`Cliente ${client.nombre} seleccionado`, { variant: 'success', solid: true });
    },

    validarFormatoEmail(contacto) {
      if (this.isfinalizado) {
        if ((contacto === "" || contacto === null) && this.enviarEncuesta) {
          this.emailValido = false;
          return;
        } else if (contacto && contacto !== "") {
          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          this.emailValido = emailRegex.test(contacto);
        } else {
          this.emailValido = true;
        }
      }
    },

handleItemBeforeHide(event) {
  // Si el cierre es programático, ya confirmado, o estamos en solo lectura,
  // NO mostramos confirmación.
  if (this.skipCloseConfirm || this.cerrarModal || this.edicionBloqueada === true) {
    this.skipCloseConfirm = false;
    this.cerrarModal = false;
    this.rowValue = null;
    this.rowIndex = null;
    this.resetEditModal();
    this.reset();
    return; // dejamos que la modal se cierre
  }

  // En modo edición sí pedimos confirmación
  const confirmacion = window.confirm("¿Estás seguro de que quieres cerrar el Item Sin Guardar?");
  if (!confirmacion) {
    // Cancelamos el cierre
    event.preventDefault();
    return;
  }

  // Confirmado: limpiamos y dejamos cerrar
  this.cerrarModal = true;
  this.rowValue = null;
  this.rowIndex = null;
  this.resetEditModal();
  this.reset();
  if (this.$refs.itemconfiguration && typeof this.$refs.itemconfiguration.hide === 'function') {
    this.$refs.itemconfiguration.hide();
  }
}
,

    formatDate(dateString) {
      const date = new Date(dateString);
      return date.toLocaleDateString("es-ES", { month: "long", year: "numeric" });
    },

    modalProyecto(button, item) {
      this.itemAnyadir = item;
      this.$root.$emit("bv::show::modal", this.infoModalProyecto.id, button);
    },

    getFile() {
      const formData = new FormData();
      formData.append("nombre", this.documento[0].nombre);
      formData.append("ruta", this.documento[0].ruta);
      formData.append("tipo", this.documento[0].tipo.split("/")[1]);

      api1.post("/api/reporting/v204/file/download", formData, {
        responseType: "blob",
        headers: { "Content-Type": "multipart/form-data" },
      }).then(response => {
        const blob = new Blob([response.data], { type: response.headers["content-type"] });
        const fileDownload = require("js-file-download");
        fileDownload(blob, this.documento[0].nombre);
      });
    },

    getFormatDate() {
      const date = new Date();
      const text = date.toLocaleDateString().replaceAll("/", "-");
      return text;
    },

    submitFile() {
      const date = this.getFormatDate();
      const buffer = new File([this.archivoSubcontratacion], `${date}_${this.archivoSubcontratacion.name}`, {
        type: this.archivoSubcontratacion.type,
      });
      const formData = new FormData();
      formData.append("file", buffer);
      formData.append("ruta", `archivoSubcontratacion/${this.numeroItem}`);

      this.documento = [{
        nombre: `${date}_${this.archivoSubcontratacion.name}`,
        ruta: `archivoSubcontratacion/${this.numeroItem}`,
        tipo: this.archivoSubcontratacion.type,
      }];

      api1.post("/api/reporting/v204/file/upload", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
    },

    messageToShow() {
      if (this.openTraining === true) {
        this.calificacionRevision = "Sin Revisión";
      }

      if ((!this.calificacionRevision || this.calificacionRevision === "") &&
        !["NoAplica(Saqratex)", "Sin Revisión"].includes(this.calificacionRevision)) {
        return "Calificación de revisión está vacía";
      }

      if ((!this.tipoRevision || this.tipoRevision === "") &&
        !["NoAplica(Saqratex)", "Sin Revisión"].includes(this.calificacionRevision)) {
        return "Tipo de revisión está vacío";
      }

      if ((this.consultor === null || this.consultor === "") &&
        !["NoAplica(Saqratex)", "Sin Revisión"].includes(this.calificacionRevision)) {
        return "Campo Consultor Revisión informe está vacío";
      }

      if ((!this.contacto || this.contacto === "") && this.enviarEncuesta === true) {
        return "Campo Persona de contacto está vacío";
      }

      if (this.$refs.hitosfacturacion && this.$refs.hitosfacturacion.todoFacturar === false) {
        return "Falta facturar algún hito de facturación";
      }

      if (!this.openTraining &&
          this.$refs.equipotrabajo &&
          this.$refs.equipotrabajo.todoFacturarMix === false &&
          this.tipoServicio !== "TESTING") {
        return "La suma de los porcentajes del equipo de trabajo no suma 100";
      }

      return "";
    },

    calcularTotalHoras() {
      this.horasEstimadasTotal = parseFloat(
        (this.horasEstimadasBecario + this.horasEstimadasSenior + this.horasEstimadasJunior).toFixed(1)
      );
      return this.horasEstimadasTotal;
    },

    agregarConsultor() {
      const nuevoId = this.consultores.length + 1;
      this.nuevoConsultor.id = nuevoId;

      const index = this.consultores.findIndex((c) => c.tipo === this.nuevoConsultor.tipo);

      if (index !== -1) {
        this.consultores[index].horas += this.nuevoConsultor.horas;
      } else {
        this.consultores.push({ ...this.nuevoConsultor });
      }

      if (this.nuevoConsultor.tipo === "Senior") {
        this.horasEstimadasSenior =
          parseFloat(this.horasEstimadasSenior) + parseFloat(this.nuevoConsultor.horas);
      } else if (this.nuevoConsultor.tipo === "Junior") {
        this.horasEstimadasJunior =
          parseFloat(this.horasEstimadasJunior) + parseFloat(this.nuevoConsultor.horas);
      } else if (this.nuevoConsultor.tipo === "Becario") {
        this.horasEstimadasBecario =
          parseFloat(this.horasEstimadasBecario) + parseFloat(this.nuevoConsultor.horas);
      }

      this.nuevoConsultor.nombre = "";
      this.nuevoConsultor.horas = 0.0;
      this.nuevoConsultor.tipo = "";
    },

    seleccionarCheckboxSubcontratado(event) {
      this.itemSubcontratado = event.target.checked;
    },
    cambiarValorCheckbox(event) {
      this.itemSubcontratado = event === "TESTING";
    },
    seleccionarCheckboxcuasiPedido(event) {
      this.cuasiPedido = event.target.checked;
    },
    seleccionarCheckboxFacturado(event) {
      this.itemFacturado = event.target.checked;
    },
  async seleccionarCheckboxFinalizado(event) {
  this.itemFinalizado = event.target.checked;

  // Solo cuando se marca a true
  if (this.itemFinalizado) {
    // Aquí se enviará la encuesta si procede
   await this.sendEncuestaEmail();
  }
},

    seleccionarCheckboxEnviarEncuesta(event) {
      this.enviarEncuesta = event.target.checked;
    },

    showMsgBoxConfirm(msg, vari, title) {
      this.$bvModal
        .msgBoxOk(msg, {
          title: title,
          size: "lg",
          buttonSize: "sm",
          okVariant: vari,
          headerClass: "p-2 border-bottom-0",
          footerClass: "p-2 border-top-0",
          centered: true,
        })
        .then((value) => {
          this.msgValue = value;
        });
    },

    async addItem() {
      this.validarFormatoEmail(this.contacto);
      if (!this.emailValido) {
        this.showMsgBoxConfirm(
          "Por favor, introduce un email con formato válido, o deselecciona enviar Encuesta",
          "danger",
          "Error"
        );
        return;
      }

      this.cerrarModal = true;
      if (this.archivoSubcontratacion.length != 0) this.submitFile();

      // 🚩 Ensayos: sólo si TESTING
      const ensayo = this.tipoServicio === "TESTING" ? this.$refs.Ensayos?.cargarEnsayo?.() : undefined;

      // Construye el objeto base (sin 'ensayo' de inicio)
      const base = {
        numeroItem: this.numeroItem,
        numeroPedido: this.numeroPedido,
        importeItem: this.$parseDecimal(this.importeItem),
        equipoTrabajo: this.openTraining ? [] : this.equipoTrabajo,
        tipoProyecto: this.tipoProyecto,
        tipoServicio: this.tipoServicio,
        fechaEntrega: this.fechaEntrega,
        informacionFaseOferta: this.informacionFaseOferta,
        descripcion: this.descripcion,
        fechaPedido: this.fechaPedido,
        textoCv: this.textoCv,
        etiquetas: this.etiquetas,
        itemSubcontratado: this.itemSubcontratado,
        avance: this.openTraining ? [] : (this.$refs.avanceItem?.avance || []),
        facturacion: this.$refs.hitosfacturacion?.hitosFacturacion || [],
        tipoRevision: this.tipoRevision,
        calificacionRevision: this.calificacionRevision,
        contacto: this.contacto,
        itemFacturado: this.itemFacturado,
        itemFinalizado: this.itemFinalizado,
        importeSubcontratacion: this.$parseDecimal(this.importeSubcontratacion),
        documentos: this.documento,
        consultor: this.consultor,
        horasEstimadasTotal: this.openTraining ? 0 : this.$parseDecimal(this.horasEstimadasTotal),
        horasEstimadasSenior: this.openTraining ? 0 : this.$parseDecimal(this.horasEstimadasSenior),
        horasEstimadasJunior: this.openTraining ? 0 : this.$parseDecimal(this.horasEstimadasJunior),
        horasEstimadasBecario: this.openTraining ? 0 : this.$parseDecimal(this.horasEstimadasBecario),
        gastosDesplazamientoIncludiosImporteItem: this.$parseDecimal(this.gastosDesplazamientoIncludiosImporteItem),
        totalFacturado: this.$parseDecimal(this.totalFacturado),
        totalProvisionado: this.$parseDecimal(this.totalProvisionado),
        horasTotalesEstimadas: this.openTraining ? 0 : (this.$refs.equipotrabajo?.horasTotalesEstimadas ?? 0),
        horasTotalesRealizadas: this.openTraining ? 0 : (this.$refs.equipotrabajo?.horasTotalesRealizadas ?? 0),
        desviacionHorasItem: this.openTraining ? 0 : (this.$refs.equipotrabajo?.desviacionHorasItem ?? 0),
        gastoDesplazamientoCosteChk: this.$refs.hitosfacturacion?.gastoDesplazamientoCosteCheck ?? false,
        gastoCertificadoChk: this.$refs.hitosfacturacion?.gastoCertificadoCheck ?? false,
        costeBonificaiconChk: this.$refs.hitosfacturacion?.costeBonificacionCheck ?? false,
        description: this.description,
        proyectoReferencias: this.openTraining ? false : this.proyectoReferencias,
        enviarEncuesta: this.enviarEncuesta,
        encuestaEnviadaItem: this.encuestaEnviadaItem,
        cuasiPedido: this.cuasiPedido,
        hitoEntregas: this.$refs.hitosEntregaItem?.hitoEntregas || [],
        prevision: this.prevision,
        fechaPrimerContactoItem: this.fechaPrimerContactoItem,
        numeroQuotation: this.numeroQuotation,
        poc: this.poc,
        informacionCambioFechaEntrega: this.informacionCambioFechaEntrega,
        fechaEntregaActualizada: this.fechaEntregaActualizada,
        consultoriaHoras: this.consultoriaHoras,
        cliente: this.openTraining ? this.cliente : null,
        cif: this.openTraining ? this.cif : "",
        sector: this.sector,
        parado: this.parado,
        observacionPrevision: this.observacionPrevision,
        fechaVisita: this.fechaVisita,
        observacionItem: this.observacionItem,
        estadoItem: this.estadoItem,
      };

      if (typeof ensayo !== "undefined") base.ensayo = ensayo;
      if (this.id !== "") base.id = this.id;

      this.itemProyecto = base;

      // Actualiza lista reactiva por ID (sin depender de índices)
      this.addLineItem();

      const ok = await this.actualizarItem();
      if (!ok) return;

      this.closeItem();

      if (this.abiertoDesdeCurso && this.idCursoOrigen) {
        state.deboVolverACursoItem = false;
        this.$router.push(`/curso/${this.idCursoOrigen}`);
      } else if (state.deboVolverACursoItem && this.idCursoOrigen) {
        state.deboVolverACursoItem = false;
        this.$router.push(`/curso/${this.idCursoOrigen}`);
      } else {
        this.$router.push({ name: "detalle-proyecto", params: { numeroOferta: this.numeroOferta } });
      }
    },

    async actualizarItem() {
      try {
        let response;
        if (this.id === "") {
          response = await api1.post("/api/dekra-projects/v204/item", this.itemProyecto);
        } else {
          response = await api1.put("/api/dekra-projects/v204/item", this.itemProyecto);
        }
        if (!state.pendingItem && response.data && response.data.message) {
          this.$bvToast.toast(response.data.message, { title: "Información", variant: "success", solid: true });
        }
        if (this.abiertoDesdeCurso && this.idCursoOrigen) {
          await this.syncCursoConEquipoTrabajo(this.idCursoOrigen);
        }
        return true;
      } catch (error) {
        this.$bvToast.toast("Error al actualizar", { title: "Error", variant: "danger", solid: true });
        return false;
      }
    },

    // Reemplaza por id si existe; si no, añade
    addLineItem() {
      const id = this.itemProyecto?.id;
      if (id) {
        const idx = this.itemList.findIndex(i => i.id === id);
        if (idx >= 0) {
          this.$set(this.itemList, idx, { ...this.itemList[idx], ...this.itemProyecto });
          return;
        }
      }
      this.itemList.push(this.itemProyecto);
    },

    reset() {
      this.id = "";
      this.numeroItem = "";
      this.numeroPedido = "";
      this.importeItem = 0;
      this.equipoTrabajo = [];
      this.tipoProyecto = "";
      this.tipoServicio = "";
      this.fechaEntrega = "";
      this.informacionFaseOferta = "";
      this.descripcion = "";
      this.textoCv = "";
      this.itemProyecto = [];
      this.etiquetas = [];
      this.itemSubcontratado = false;
      this.facturacion = [];
      this.avance = [];
      this.fechaPedido = "";
      this.tipoRevision = "";
      this.calificacionRevision = "";
      this.contacto = "";
      this.itemFacturado = "";
      this.itemFinalizado = "";
      this.importeSubcontratacion = 0;
      this.documento = [];
      this.consultor = null;
      this.horasEstimadasTotal = "";
      this.horasEstimadasSenior = 0;
      this.horasEstimadasJunior = 0;
      this.horasEstimadasBecario = 0;
      this.gastosDesplazamientoIncludiosImporteItem = 0;
      this.totalFacturado = 0;
      this.totalProvisionado = 0;
      this.horasTotalesEstimadas = 0;
      this.horasTotalesRealizadas = 0;
      this.desviacionHorasItem = 0;
      this.gastoDesplazamientoCosteChk = false;
      this.gastoCertificadoChk = false;
      this.costeBonificaiconChk = false;
      this.description = "";
      this.enviarEncuesta = true;
      this.proyectoReferencias = true;
      this.consultoriaHoras = false;
      this.poc = false;
      this.informacionCambioFechaEntrega = "";
      this.cuasiPedido = false;
      this.prevision = [];
      this.importeMes = [];
      this.fechaPrimerContactoItem = "";
      this.fechaEntregaActualizada = "";
      this.cliente = null;
      this.cif = "";
      this.sector = "";
      this.fechaVisita = "";
      this.parado = false;
      this.observacionPrevision = "";
      this.numeroQuotation = "";
      this.observacionItem = "";

      if (this.tipoServicio === "TESTING") {
        this.$refs.Ensayos?.resetEnsayos();
      }
      if (this.$refs.hitosEntregaItem) {
        this.$refs.hitosEntregaItem.hitoEntregas = [];
      }
    },

    loadItem(row) {
      this.edit = true;
      this.rowValue = row;
      this.$refs.itemconfiguration.show();
    },

    loadItem2(row) {
      this.id = row.item.id;
      this.numeroItem = row.item.numeroItem;
      this.numeroQuotation = row.item.numeroQuotation;
      this.importeItem = row.item.importeItem;
      this.numeroPedido = row.item.numeroPedido;
      this.tipoProyecto = row.item.tipoProyecto;
      this.tipoServicio = row.item.tipoServicio;
      this.fechaPedido = row.item.fechaPedido;
      this.fechaEntrega = row.item.fechaEntrega;
      this.informacionFaseOferta = row.item.informacionFaseOferta;
      this.descripcion = row.item.descripcion;
      this.textoCv = row.item.textoCv;
      this.informacionCambioFechaEntrega = row.item.informacionCambioFechaEntrega;
      this.etiquetas = row.item.etiquetas;
      this.consultoriaHoras = row.item.consultoriaHoras;
      this.fechaEntregaActualizada = row.item.fechaEntregaActualizada;
      this.itemSubcontratado = row.item.itemSubcontratado;

      this.$refs.hitosfacturacion && (this.$refs.hitosfacturacion.hitosFacturacion = row.item.facturacion);
      this.$refs.Ensayos && this.$refs.Ensayos.loadItemEnsayo && this.$refs.Ensayos.loadItemEnsayo(row.item.ensayo);

      this.gastosDesplazamientoIncludiosImporteItem = row.item.gastosDesplazamientoIncludiosImporteItem;
      this.totalFacturado = row.item.totalFacturado;
      this.totalProvisionado = row.item.totalProvisionado;
      this.tipoRevision = row.item.tipoRevision;
      this.calificacionRevision = row.item.calificacionRevision;
      this.contacto = row.item.contacto;
      this.itemFacturado = row.item.itemFacturado;
      this.itemFinalizado = row.item.itemFinalizado;
      this.poc = row.item.poc;
      this.importeSubcontratacion = row.item.importeSubcontratacion;
      this.documento = row.item.documentos;
      this.consultor = row.item.consultor;
      this.horasEstimadasTotal = row.item.horasEstimadasTotal;
      this.horasEstimadasSenior = row.item.horasEstimadasSenior;
      this.horasEstimadasJunior = row.item.horasEstimadasJunior;
      this.horasEstimadasBecario = row.item.horasEstimadasBecario;
      this.description = row.item.description;
      this.rowIndex = row.index;
      this.proyectoReferencias = row.item.proyectoReferencias;
      this.enviarEncuesta = row.item.enviarEncuesta;
      this.encuestaEnviadaItem = row.item.encuestaEnviadaItem;
      this.cuasiPedido = row.item.cuasiPedido;
      this.prevision = row.item.prevision;
      this.fechaPrimerContactoItem = row.item.fechaPrimerContactoItem;
      this.estadoItem = row.item.estadoItem;

      this.equipoTrabajo = [...(row.item.equipoTrabajo || [])];

      this.cliente = this.openTraining ? row.item.cliente || {} : null;
      this.cif = this.openTraining ? row.item.cif || "" : "";
      this.sector = row.item.sector;
      this.fechaVisita = row.item.fechaVisita;
      this.parado = row.item.parado;
      this.observacionPrevision = row.item.observacionPrevision;
      this.observacionItem = row.item.observacionItem;

      this.$nextTick(() => {
        if (!this.openTraining && this.$refs.avanceItem) {
          this.$refs.avanceItem.avance = row.item.avance ? [...row.item.avance] : [];
        }
        if (this.$refs.hitosEntregaItem) {
          this.$refs.hitosEntregaItem.hitoEntregas = row.item.hitoEntregas ? [...row.item.hitoEntregas] : [];
        }
      });
    },

    ordenarPorNumeroItem() {
      this.itemList.sort((a, b) => a.numeroItem - b.numeroItem);
    },

   closeItem() {
  const skipConfirm = this.edicionBloqueada === true || this.cerrarModal === true;

  if (!skipConfirm) {
    const confirmacion = window.confirm("¿Estás seguro de que quieres cerrar el Item Sin Guardar?");
    if (!confirmacion) return;
  }

  this.cerrarModal = true;
  this.rowValue = null;
  this.rowIndex = null;
  this.resetEditModal();
  this.reset();
  if (this.$refs.itemconfiguration && typeof this.$refs.itemconfiguration.hide === 'function') {
    this.$refs.itemconfiguration.hide();
  }
},


    deleteLineItem(row) {
      this.itemList.splice(row.index, 1);
    },
    deleteLineDefect(row) {
      this.defects.splice(row.index, 1);
    },
    deleteLineRework(row) {
      this.reworks.splice(row.index, 1);
    },
    resetEditModal() {
      this.edit = false;
    },
  },

  computed: {
     localOptionsSectores() {
    return Array.isArray(this.optionsSectores) ? [...this.optionsSectores] : [];
  },
    dynamicTableFields() {
      return [
        { key: "descripcion", label: this.openTraining ? "Cliente" : "Descripcion", sortable: false },
        { key: "numeroItem", label: "Numero Item", sortable: false },
        { key: "fechaEntrega", label: "Fecha Entrega", sortable: false },
        { key: "fechaEntregaActualizada", label: "Fecha Actualizada", sortable: false },
        { key: "importeItem", label: "Importe", sortable: false },
        { key: "itemFinalizado", label: "Finalizado", sortable: false },
        { key: "action", label: "", thStyle: { width: "120px" } },
      ];
    },
    currentUser() {
      return this.$store.state.auth.user;
    },
   esCuasiPedido() {
  return (this.itemList || []).every(h => h.cuasiPedido === true);
},
    empleadosFiltradosOrdenados() {
      const empleadosFiltrados = this.consultoresProyecto.filter(
        (empleado) => empleado.idioma === "ESP" && empleado.estado
      );
      return empleadosFiltrados.sort((a, b) => a.nombre.localeCompare(b.nombre));
    },
    isfinalizado() {
      return this.itemFinalizado == true;
    },
    isCheckboxDisabled() {
      return (
        (this.consultor === "" &&
          this.calificacionRevision !== "NoAplica(Saqratex)" &&
          this.calificacionRevision !== "Sin Revisión") ||
        (this.calificacionRevision === "" &&
          this.calificacionRevision !== "NoAplica(Saqratex)" &&
          this.calificacionRevision !== "Sin Revisión") ||
        (this.tipoRevision === "" &&
          this.calificacionRevision !== "NoAplica(Saqratex)" &&
          this.calificacionRevision !== "Sin Revisión") ||
        (this.contacto === "" && this.enviarEncuesta === true) ||
        (this.$refs.hitosfacturacion && this.$refs.hitosfacturacion.todoFacturar === false) ||
        (this.tipoServicio !== "TESTING" &&
          !this.openTraining &&
          this.$refs.equipotrabajo &&
          this.$refs.equipotrabajo.todoFacturarMix === false)
      );
    },
    sortedOptionsTipoProyectoEsp() {
      return [...this.$constants().optionsTipoProyectoEsp].sort((a, b) => {
        return a.text.localeCompare(b.text);
      });
    },
  },

  mounted() {
    
     if (!state.pendingItem) {
    state.deboVolverACursoItem = false;
  }
    // Detectar si venimos desde Cursos.vue
    if (state.pendingItem) {
      this.abiertoDesdeCurso = true;
      this.abrirModalConItem(state.pendingItem);
      state.pendingItem = null;
    }

    this.$root.$on("bv::modal::shown", (bvEvent, modalId) => {
      if (modalId === "itemconfiguration") {
        if (this.abiertoDesdeCurso) {
          return;
        }
        if (this.rowValue && this.rowValue.item && this.rowValue.item.id) {
          this.$nextTick(() => {
            this.loadItem2({ item: this.rowValue.item, index: this.rowValue.index });
          });
        } else {
          console.warn("No se pudo cargar el item desde Project.vue");
        }
      }
    });

    this.ordenarPorNumeroItem();

    

    api1.get("/api/dekra/v204/empleado").then(r => { this.consultoresProyecto = r.data; });
    this.cargarClientes();
    
    // Fetch global lock state to ensure new items inherit it
    api1.get("/api/dekra-projects/v204/itemEstadoBloqueado")
      .then(r => {
        if (r.data === true) {
          this.estadoItem = true;
        }
      })
      .catch(err => console.error("Error al cargar estado de bloqueo global:", err));
  },

  created() {
    if (state.pendingItem) {
      this.abiertoDesdeCurso = !!state.pendingItem.idCurso;
      this.idCursoOrigen = state.pendingItem.idCurso;
    }
  },

  beforeDestroy() {
    this.$root.$off("bv::modal::shown");
  },

  components: {
    VueJsonPretty,
    EquipoTrabajo,
    AvanceItem,
    HitosFacturacion,
    Proyecto,
    Ensayos,
    Clientes,
    HitosEntregaItem
  },

  watch: {
    contacto(newEmail) {
      this.validarFormatoEmail(newEmail);
    },
    openTraining(newVal) {
      if (newVal) this.equipoTrabajo = [];
    },
  },
};
</script>

<style>
.subrayado {
  text-decoration: underline;
  color: blue;
}
.custom-checkbox {
  width: 20px;
  height: 20px;
}

.modal-title {
  font-size: 200%;
  color: #27642b;
}
.error-message {
  color: red;
  font-size: 90%;
  margin-top: 4px;
}
.table-container {
  display: flex;
  justify-content: center;
}
.tabla-consultores {
  border-collapse: collapse;
  width: 70%;
}
.tabla-consultores th,
.tabla-consultores td {
  border: 1px solid #ccc;
  padding: 8px;
  text-align: center;
}
.tabla-consultores th {
  background-color: #f2f2f2;
}
</style>
